import qs from "qs";
import {useTranslation} from "react-i18next";
import TranslationUtil from "@/utils/TranslationUtil";
import {TimecardEndpoints} from "@/services/Template/endpoints";
import request from '@/utils/Request';

export interface ColumnConfig {
  label: string;
  key: string;
  isCheck: boolean;
  required: boolean;
  sort: number;
}


export interface ColumnSettings {
  id: string;
  template_name: string;
  is_active: boolean;
  is_default: boolean;
  template_field: ColumnConfig[];
}

export interface SaveNewTemplateData {
  data: ColumnSettings;
}

const timecardConfig = [
  {
    template_name: "Timecard Report",
    is_active: true,//使用
    is_default: true,
    template_field: [
      {
        // label: TranslationUtil.t("hr.employee.Person Name"),
        label: "Person Name",
        key: "employee_name",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 1, //排序
      },
      {
        // label: '' + TranslationUtil.t("hr.employee.Person ID"),
        label: 'Person ID',
        key: "employee_code",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 2, //排序
      },
      {
        label: 'Date',
        key: "att_date",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 3, //排序
      },
      {
        label: 'Timesheet',
        key: "timesheet_name",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 4, //排序
      },
      {
        label: 'Clock In',
        key: "clock_in",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 5, //排序
      },
      {
        label: 'Break In',
        key: "break_in",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 6, //排序
      },
      {
        label: 'Break Out',
        key: "break_out",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 7, //排序
      },
      {
        label: 'Clock Out',
        key: "clock_out",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 8, //排序
      },
      {
        label: 'Clock Time(h)',
        key: "period_hrs",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 9, //排序
      },
      {
        label: "Total Work Time(h)",
        key: "paid_work_deduct_break",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 10, //排序
      },
      {
        label: "Total Overtime Time(h)",
        key: "overtime_hrs",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 11, //排序
      },
      {
        label: "Total Time(h)",
        key: "paid_work",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 12, //排序
      },
      {
        label: "Total Break Time(h)",
        key: "paid_break",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 13, //排序
      },
      {
        label: "Statistic Rule Mode",
        key: "pairing",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 14, //排序
      },
      {
        label: "Abnormal Situation",
        key: "abnormal_situation",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 15, //排序
      },
    ],
  },
];

const attendanceConfig = [
  {
    template_name: "Attendance Report",
    is_active: true,//使用
    is_default: true,
    template_field: [
      {
        label: "Person ID",
        key: "employee_code",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 1, //排序
      },
      {
        label: "Person Name",
        key: "employee_name",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 2, //排序
      },
      {
        label: "Timesheet",
        key: "timesheet_names",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 3, //排序
      },
      {
        label: "Date",
        key: "att_dates",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 4, //排序
      },
      {
        label: "total_late_in",
        key: "total_late_in",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 5, //排序
      },
      {
        label: "total_early_out",
        key: "total_early_out",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 6, //排序
      },
      {
        label: "Total_break",
        key: "total_break",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 7, //排序
      },
      {
        label: "Total_paid_work",
        key: "total_paid_work_deduct_break",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 8, //排序
      },
      {
        label: "Total_overtime",
        key: "total_overtime_hrs",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 9, //排序
      },
      {
        label: "Total_work",
        key: "total_paid_work",
        isCheck: true, //是否选中
        required: false, //是否必选
        sort: 10, //排序
      },
    ],
  },
];

export const getDefaultColumnSettings = async (type: string) => {
  if (type == 'timecard') {
    return new Promise((resolve, reject) => {
      resolve(timecardConfig);
    });
  } else if (type === 'overtime_analysis') {
    const overtimeConfig = [
      {
        template_name: "Overtime Analysis Report",
        is_active: true,
        is_default: true,
        template_field: [
          {
            label: "Person ID",
            key: "employee_code",
            isCheck: true,
            required: false,
            sort: 1,
          },
          {
            label: "Person Name",
            key: "employee_name",
            isCheck: true,
            required: false,
            sort: 2,
          },
          {
            label: "Department",
            key: "department_name",
            isCheck: true,
            required: false,
            sort: 3,
          },
          {
            label: "Total Work Time",
            key: "total_paid_work_deduct_break",
            isCheck: true,
            required: false,
            sort: 4,
          },
          {
            label: "T1 OT Hours",
            key: "ot1_hrs",
            isCheck: true,
            required: false,
            sort: 5,
          },
          {
            label: "T2 OT Hours",
            key: "ot2_hrs",
            isCheck: true,
            required: false,
            sort: 6,
          },
          {
            label: "OT Ratio",
            key: "ot_ratio",
            isCheck: true,
            required: false,
            sort: 7,
          },
          {
            label: "Risk Level",
            key: "risk_level",
            isCheck: true,
            required: false,
            sort: 8,
          },
        ],
      },
    ];
    return new Promise((resolve, reject) => {
      resolve(overtimeConfig);
    });
  } else {
    return new Promise((resolve, reject) => {
      resolve(attendanceConfig);
    });
  }
};


//根据表格ID取表格配置
export const getColumnSettings = async (type: string) => {
  if (type == 'timecard') {
    const response = await request.authorizedAxios().post(TimecardEndpoints.REPORT_TEMPLATE_LIST, {report_type: 1});
    return response?.data;
  } else if (type === 'overtime_analysis') {
    const response = await request.authorizedAxios().post(TimecardEndpoints.REPORT_TEMPLATE_LIST, {report_type: 3});
    return response?.data;
  } else {
    const response = await request.authorizedAxios().post(TimecardEndpoints.REPORT_TEMPLATE_LIST, {report_type: 2});
    return response?.data;
  }
};


export const deleteTemplate = async (id: any) => {
  const response = await request.authorizedAxios().delete(`${TimecardEndpoints.REPORT_TEMPLATE}${id}/`);
  return response?.data;
}

export const saveTemplate = async (data: any) => {
  const response = await request.authorizedAxios().post(`${TimecardEndpoints.REPORT_TEMPLATE}`, data);
  return response?.data;
}

export const updateTemplate = async (id: string, data: any) => {
  const response = await request.authorizedAxios().put(`${TimecardEndpoints.REPORT_TEMPLATE}${id}/`, data);
  return response?.data;
}


//保存新模板
export const SaveNewTemplate = async (data: SaveNewTemplateData) => {
  return new Promise((resolve, reject) => {
    timecardConfig.push(data.data);
    resolve(timecardConfig);
  });
}


//保存并应用，将当前模版设置为激活状态，其他设置为未激活状态
export const SaveAndApply = async (data: SaveNewTemplateData) => {
  return new Promise((resolve, reject) => {
    timecardConfig.forEach((item) => {
      if (item.template_name === data.data.template_name) {
        item = data.data;
        item.is_active = true;
      } else {
        item.is_active = false;
      }
    });
    resolve(timecardConfig);
  });
}

export const SaveConfig = async (data: SaveNewTemplateData) => {
  return new Promise((resolve, reject) => {
    timecardConfig.forEach((item) => {
      if (item.template_name === data.data.template_name) {
        item = data.data;
      }
    });
    resolve(timecardConfig);
  });
}


export const deleteConfig = async (data: SaveNewTemplateData) => {
  return new Promise((resolve, reject) => {
    const new_timecardConfig = timecardConfig.filter((item) => item.template_name !== data.data.template_name);
    resolve(new_timecardConfig);
  });
}
